import { useTransition } from 'react';
import { useTranslation } from 'react-i18next';
import { useAtom } from 'jotai';
import { styled } from 'goober';

import { CreateDropdownWithButton } from '@/components/create-dropdown/create-dropdown-with-button';
import { AskXButton } from '@/features/ask-x/ask-x-button';
import { Flexbox } from '@/ui/flexbox/flexbox';
import { Inline } from '@/ui/line/line';
import { TabControl } from '@/ui/tabs/tab-control';

import type { FeedTab } from './feed.state';
import { feedActiveTabState } from './feed.state';
import { FeedTabControl } from './feed-tab-control';
import { useFeedTabsConfig } from './use-feed-tabs-config';

export const FeedToolbar = () => {
  const { t } = useTranslation('feed', { keyPrefix: 'tabs' });
  const feedTabsConfig = useFeedTabsConfig();
  const [activeTab, setActiveTab] = useAtom(feedActiveTabState);
  const [, startTransition] = useTransition();

  const switchTab = (tabId: FeedTab): void => {
    startTransition(() => setActiveTab(tabId));
  };

  return (
    <Toolbar alignItems="flex-end" gap="24px" justify="space-between" fullWidth>
      <TabsStrip alignItems="flex-end" gap="32px" grow={1}>
        {feedTabsConfig.map(tab => (
          <TabControl
            isActive={activeTab === tab.id}
            key={tab.id}
            onClick={() => switchTab(tab.id)}
            title={<FeedTabControl id={tab.id} name={t(tab.id)} />}
            variant="feed"
          />
        ))}
      </TabsStrip>
      <Actions alignItems="center" gap="8px">
        <AskXButton />
        <CreateDropdownWithButton />
      </Actions>
    </Toolbar>
  );
};

const Toolbar = styled(Flexbox)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray.c2};
  flex-shrink: 0;
  padding: 28px 40px 0;
`;

const TabsStrip = styled(Flexbox)`
  min-width: 0;
`;

const Actions = styled(Inline)`
  flex-shrink: 0;
  padding-bottom: 10px;
`;
